// extracted by mini-css-extract-plugin
export default {"wrapper":"RC-z","viewport":"SC-z","container":"TC-z","slide":"UC-z"};